import React from "react";
import { Link } from "react-router-dom";
import Ayushman from "../assests/image/Ayushman.webp";
import CompanyItDose from "../assests/image/company_itdose.webp";
import logo from "../assests/image/img/logo/footer/logo-dark.png";
import img11 from "../assests/image/img/achievements/abdm.webp";

const Footer = () => {
  return (
    <footer className="footer-area footer-bg">
      <div className="container">
        <div className="footer-midal">
          <div className="row">
            <div className="col-lg-4 col-sm-7">
              <div className="footer-widget">
                <h3>Our Products</h3>
                <ul className="footer-list">
                  <li>
                    <a href="hospital-information-and-management-system">
                      HOSPEDIA - Hospital Information &amp; Management System
                    </a>
                  </li>
                  <li>
                    <a href="laboratory-information-and-management-system">
                      INNOPATH - Laboratory Information &amp; Management System
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-2 col-sm-5">
              <div className="footer-widget">
                <h3>Resources</h3>
                <ul className="footer-list">
                  <li>
                    <a href="our-team">Our Team</a>
                  </li>
                  <li>
                    <a href="/#our-services">Our Services</a>
                  </li>
                  <li>
                    <a href="/#testimonials">Testimonials</a>
                  </li>
                  <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/terms-and-conditions">Terms &amp; Conditions</a>
                  </li>
                  <li>
                    <a href="/#cookie-policy">Cookie Policy</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-sm-7">
              <div className="footer-widget ps-5">
                <h3>Company</h3>
                <ul className="footer-list">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="about-the-company">About The Company</a>
                  </li>
                  <li>
                    <a href="vision-mission-and-values">
                      Vision, Mission &amp; Values
                    </a>
                  </li>
                  <li>
                    <a href="contact-us">Contact</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-sm-5">
              <div className="footer-widget blackfoo">
                <h3>Address</h3>
                <ul className="footer-list-two">
                  <li>
                    <i className="flaticon-telephone"></i>
                    <a href="tel:+91-120-3200792,+911203200791">
                      +91-120-3200792 ,+911203200791
                    </a>
                  </li>
                  <li>
                    <i className="flaticon-email-1"></i>
                    <a href="mailto:info@itdoseinfo.com">info@itdoseinfo.com</a>
                  </li>
                  <li>
                    <i className="flaticon-place"></i>
                    HEAD OFFICE : G-19, G-Block, Sector 6, Noida, Uttar Pradesh
                    201301
                    <br />
                    AFRICA : Spring Valley, Business Park,
                    <br />
                    Off Lower Kabete Rd, Nairobi, Kenya
                    <br />
                    Mob.: +254 745818058
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <hr className="line" />

        <div className="row">
          <div className="col-lg-2 col-sm-5">
            <div className="footer-widget">
              <div className="footer-img">
                {/* <img src={logo} className="ITDOSE INFOSYSTEMS Logo2" alt="Itdose" loading="lazy" /> */}
                <img src={logo} className="ITDOSE INFOSYSTEMS Logo2" alt="Itdose" loading="lazy" />
              </div>
            </div>
          </div>

          <div className="col-lg-10 col-sm-5">
            <div className="footer-widget">
              <span style={{ width: "100%" }}>
                ITDOSE INFOSYSTEMS PVT. LTD. is a novel vision of young and
                enthusiastic entrepreneur dedicated to developing and delivering
                innovative and apt business solutions. At ITDOSE, we are
                transforming creative ideas into next-generation cutting-edge
                technologies through consistent research and development
                process.
              </span>
            </div>
          </div>

          <div className="col-lg-4 col-sm-5">
            <div className="footer-social-icon">
              <ul className="social-link">
                <li>
                  <a href="https://twitter.com/itdoseinfo" target="_blank" rel="noopener noreferrer">
                    <img
                      src="https://cdn.simpleicons.org/x"
                      alt="Twitter X"
                      width="26"
                      loading="lazy"
                    />
                  </a>
                </li>

                <li>
                  <a href="https://facebook.com/itdoseinfo" target="_blank" rel="noopener noreferrer">
                    <img
                      src="https://cdn.simpleicons.org/facebook"
                      alt="Facebook"
                      width="30"
                      loading="lazy"
                    />
                  </a>
                </li>

                <li>
                  <a href="https://linkedin.com/company/itdose" target="_blank" rel="noopener noreferrer">
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png"
                      alt="LinkedIn"
                      width="26"
                      loading="lazy"
                    />
                  </a>



                </li>

                <li>
                  <a href="https://instagram.com/itdoseinfosystems" target="_blank" rel="noopener noreferrer">
                    <img
                      src="https://cdn.simpleicons.org/instagram"
                      alt="Instagram"
                      width="28"
                      loading="lazy"
                    />
                  </a>
                </li>

                <li>
                  <a href="https://youtube.com/channel/UCUltjTYne7tfPQsiSSQKjMQ" target="_blank" rel="noopener noreferrer">
                    <img
                      src="https://cdn.simpleicons.org/youtube"
                      alt="YouTube"
                      width="30"
                      loading="lazy"
                    />
                  </a>
                </li>
              </ul>

            </div>



          </div>

          <div className="col-lg-4 col-sm-5">
            <div className="footer-widget">
              <div
                className="footer-img footer-img-container"
              // style={{
              //   flexWrap: "nowrap",
              //   justifyContent: "flex-start",
              //   gap: "8px",
              // }}
              >
                <img src={CompanyItDose} className="Companies logo" alt="Images" loading="lazy"  />
                <img
                  src={Ayushman}
                  className="footer-img footer-img-height"
                  alt="Certificate of Ayushman Bharat"
                  style={{
                    marginTop: "7px",
                    // height: "67px",
                    borderRadius: "50px",
                    loading: "lazy",
                  }}
                />
                <img
                  src={img11}
                  className="footer-img footer-img-height"
                  alt="Award of NABH"
                  style={{
                    marginTop: "7px",
                    // height: "67px",
                    borderRadius: "50px",
                    loading: "lazy",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <a
          href="https://api.whatsapp.com/send?phone=919654482139&amp;text=Hello"
          id="wh-footer"
          target="_blank"
        >
          <i class="bx bxl-whatsapp" id="wh-footer-i"></i>
        </a>

        <div className="copy-right-area">
          <div className="row">
            <div className="col-lg-8">
              <div className="copy-right-text text-left">
                <p>
                  Copyright @
                  <script>document.write(new Date().getFullYear())</script>2025
                  ITDOSE. All Rights Reserved by ITDOSE
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    webicent
                  </a>
                </p>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="copy-right-list">
                <ul>
                  <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/terms-and-conditions">Terms &amp; Conditions</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
